import { DengueActivitiesInteractor, DengueActivitiesRequest, DengueActivitiesStructRequest } from "../../Coordinator/DengueActivities/DengueActivitiesInteractor";

export class DengueActivitiesViewModel {
	private interactor: DengueActivitiesInteractor;

	constructor() {
		this.interactor = new DengueActivitiesInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new DengueActivitiesRequest(
			obj["sgepatividadedengue"] ? parseInt(obj["sgepatividadedengue"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new DengueActivitiesStructRequest(obj["sgepatividadedengue"] ? parseInt(obj["sgepatividadedengue"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}